<div class="dash-content">
  <div class="grid">
    <div class="col-12">
      <div class="dash-header" style="margin-bottom: 8px;">
        <div>
          <div class="dash-title">ChartLine</div>
          <div class="dash-sub">Implementación del componente app-chart-line.</div>
        </div>
      </div>
    </div>

    <!-- ─── CHART LINE ─────────────────────────────── -->
    <div class="col-12 md:col-6">
      <div class="dash-card h-full">
        <div class="dash-header">
          <div>
            <div class="dash-title">{{ lineTitle }}</div>
            <div class="dash-sub">{{ lineSub }}</div>
          </div>
        </div>
        <div class="dash-body">
          <app-chart-line [config]="lineConfig" [data]="lineData"></app-chart-line>
        </div>
      </div>
    </div>

    <!-- ─── CHART LINE — GROUP BY ─────────────────── -->
    <div class="col-12 md:col-6">
      <div class="dash-card h-full">
        <div class="dash-header">
          <div>
            <div class="dash-title">{{ groupByTitle }}</div>
            <div class="dash-sub">{{ groupBySub }}</div>
          </div>
        </div>
        <div class="dash-body">
          <app-chart-line [config]="groupByConfig" [data]="groupByData"></app-chart-line>
        </div>
      </div>
    </div>

    <!-- ─── CHART LINE MULTIPLE ────────────────────── -->
    <div class="col-12">
      <div class="dash-header">
        <div>
          <div class="dash-title">{{ multipleTitle }}</div>
          <div class="dash-sub">{{ multipleSub }}</div>
        </div>
      </div>
      <app-chart-line-multiple [config]="multipleConfig" [data]="multipleData"></app-chart-line-multiple>
    </div>

    <div class="col-12">
      <div class="dash-header" style="margin-bottom: 8px;">
        <div>
          <div class="dash-title">ChartBar</div>
          <div class="dash-sub">Implementación del componente app-chart-bar.</div>
        </div>
      </div>
    </div>

    <!-- ─── CHART BAR ──────────────────────────────── -->
    <div class="col-12 md:col-6">
      <div class="dash-card h-full">
        <div class="dash-header">
          <div>
            <div class="dash-title">{{ barTitle }}</div>
            <div class="dash-sub">{{ barSub }}</div>
          </div>
        </div>
        <div class="dash-body">
          <app-chart-bar [config]="barConfig" [data]="barData"></app-chart-bar>
        </div>
      </div>
    </div>

    <!-- ─── CHART BAR STACKED ──────────────────────── -->
    <div class="col-12 md:col-6">
      <div class="dash-card h-full">
        <div class="dash-header">
          <div>
            <div class="dash-title">{{ barStackedTitle }}</div>
            <div class="dash-sub">{{ barStackedSub }}</div>
          </div>
        </div>
        <div class="dash-body">
          <app-chart-bar-stacked [config]="barStackedConfig" [data]="barStackedData"></app-chart-bar-stacked>
        </div>
      </div>
    </div>

    <!-- ─── CHART BAR MULTIPLE ─────────────────────── -->
    <div class="col-12">
      <div class="dash-header">
        <div>
          <div class="dash-title">{{ barMultipleTitle }}</div>
          <div class="dash-sub">{{ barMultipleSub }}</div>
        </div>
      </div>
      <app-chart-bar-multiple [config]="barMultipleConfig" [data]="barMultipleData"></app-chart-bar-multiple>
    </div>

    <div class="col-12">
      <div class="dash-header" style="margin-bottom: 8px;">
        <div>
          <div class="dash-title">ChartDonut</div>
          <div class="dash-sub">Implementación del componente app-chart-donut.</div>
        </div>
      </div>
    </div>

    <!-- ─── CHART DONUT ────────────────────────────── -->
    <div class="col-12 md:col-6">
      <div class="dash-card h-full">
        <div class="dash-header">
          <div>
            <div class="dash-title">{{ donutTitle }}</div>
            <div class="dash-sub">{{ donutSub }}</div>
          </div>
        </div>
        <div class="dash-body">
          <app-chart-donut [config]="donutConfig" [data]="donutData"></app-chart-donut>
        </div>
      </div>
    </div>

    <!-- ─── CHART DONUT GROUP ──────────────────────── -->
    <div class="col-12">
      <div class="dash-header">
        <div>
          <div class="dash-title">{{ donutGroupTitle }}</div>
          <div class="dash-sub">{{ donutGroupSub }}</div>
        </div>
      </div>
      <app-chart-donut-group [config]="donutGroupConfig" [data]="donutGroupData"></app-chart-donut-group>
    </div>
  </div>
</div>
